import { Button } from "antd";
import { FaInstagram, FaFacebookF, FaWhatsapp, FaEnvelope } from "react-icons/fa";

export const ExploraMiradas = () => {
  return (
    <div style={{ padding: "0 20px 60px 20px" }}>
      <div className="container-fluid2" style={{ maxWidth: "800px", margin: "0 auto" }}>

        <div style={{ backgroundColor: "#22253b", color: "white", padding: "10px", textAlign: "center", marginBottom: "30px" }}>
          <h2 style={{ margin: 0, fontWeight: "bold", color: "white", fontSize: "22px" }}>Explora Miradas Medellín</h2>
        </div>

        <p className="text-center mb-5" style={{ fontSize: "15px", maxWidth: "700px", margin: "0 auto 30px auto" }}>
          Sigue las novedades de Miradas Medellín a través de las redes sociales de la <strong>Cinemateca Distrital de Medellín</strong> y acompaña una nueva edición del encuentro cinematográfico de la ciudad.
        </p>

        <div className="row mt-4">
          <div className="col-md-5 d-flex flex-column justify-content-center" style={{ gap: "15px", paddingRight: "30px" }}>
            <Button
              icon={<FaInstagram style={{ marginRight: 8 }} />}
              style={{ backgroundColor: "#d9d9d9", color: "#22253b", fontWeight: "bold", fontSize: "16px", height: "45px", borderRadius: "5px", border: "none", display: "flex", alignItems: "center", justifyContent: "center" }}
              onClick={() => window.open("https://www.instagram.com/cinematecademedellin", "_blank", "noopener,noreferrer")}
            >
              Instagram
            </Button>
            <Button
              icon={<FaWhatsapp style={{ marginRight: 8 }} />}
              style={{ backgroundColor: "#3a3c54", color: "white", fontWeight: "bold", fontSize: "16px", height: "45px", borderRadius: "5px", border: "none", display: "flex", alignItems: "center", justifyContent: "center" }}
              onClick={() => window.open("#", "_blank", "noopener,noreferrer")}
            >
              Canal de Whatsapp
            </Button>
            <Button
              icon={<FaEnvelope style={{ marginRight: 8 }} />}
              style={{ backgroundColor: "#3a3c54", color: "white", fontWeight: "bold", fontSize: "16px", height: "45px", borderRadius: "5px", border: "none", display: "flex", alignItems: "center", justifyContent: "center" }}
              onClick={() => window.open("#", "_blank", "noopener,noreferrer")}
            >
              Boletín
            </Button>
            <Button
              icon={<FaFacebookF style={{ marginRight: 8 }} />}
              style={{ backgroundColor: "#3a3c54", color: "white", fontWeight: "bold", fontSize: "16px", height: "45px", borderRadius: "5px", border: "none", display: "flex", alignItems: "center", justifyContent: "center" }}
              onClick={() => window.open("https://facebook.com/cinematecademedellin", "_blank", "noopener,noreferrer")}
            >
              Facebook
            </Button>
          </div>

          <div className="col-md-7 mt-4 mt-md-0 text-center">
            <div style={{ border: "1px solid #ccc", borderRadius: "10px", overflow: "hidden", backgroundColor: "white", width: "100%" }}>
              <iframe
                src="https://www.instagram.com/cinematecademedellin/embed"
                width="100%"
                height="420"
                title="Instagram Cinemateca Distrital de Medellín"
                style={{ display: "block", border: "none" }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
